import React, { Component } from "react";
import { Container } from "semantic-ui-react";

class About extends Component {

	render () {

		return (

			<Container>
				<p>My name is Jacob Lamont. I live in Dallas, GA – one of the western-most suburbs of Atlanta, GA.</p>
				<p>I love going to church, eating awesome food, watching a really good movie, staring slack-jawed at beautiful scenery, taking photographs, occasionally editing videos, listening to great music, occasionally playing music (bagpipes), traveling (anyplace, whenever possible), teaching kids, volunteering with <a target="_blank" href="https://outofdarkness.org/">an Atlanta based anti sex-trafficking ministry</a>, learning about what other people do, spending time with family, and writing run-on sentences that would make poor Mrs. Wilcox shake her head.</p>
				<p>I’ve been working in web development for seven years. It all started when I thought I&#39;d &quot;throw&quot; a website together for my brother&#39;s business (really, really good fudge and caramel sauce! [insert <a target="_blank" href="https://www.slickepott.com/">shameless plug</a> here]). Well, I got hooked and spent the first two years of my career building static websites in HTML and CSS for personal clients. Upon being hired by a small news organization, I added PHP for custom WordPress themes, jQuery, and MySQL to that stack. After just under three years with them, I went to work for a startup called <a target="_blank" href="https://www.quietyme.com/">Quietyme</a> where I was able to use Node.js for processing data, a PHP framework called Yii for a RESTful API, and React/Flux for the frontend web app.</p>
				<p>Currently, I'm super excited about how pattern libraries can create a better developer experience, and thus better user experiences, since they help ensure more consistent design and functionality.</p>
			</Container>

		);

	}

}

export default About;



/** WEBPACK FOOTER **
 ** ./src/modules/About.js
 **/